/**
 * @param {HTMLSpanElement} el 元素
 * @param {any} binding 对象
 * @param {Vue} vnode Vue
 */
function inserted (el, binding, vnode) {
  el.style.position = 'absolute'
  el.style.zIndex = '1000'

  const ei = document.createElement('i')
  ei.style.cursor = 'move'
  ei.style.fontSize = '16px'
  ei.className = 'ivu-icon ivu-icon-arrow-move'
  ei.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  el.prepend(ei)

  let isPress = false

  /**
   * 移动计算
   * @param {MouseEvent} e 鼠标事件
   */
  const moveHandler = (e) => {
    e.preventDefault()
    if (isPress === false) return
    const tmp = el.parentElement.getBoundingClientRect()
    const diffx = e.clientX - tmp.left
    const diffy = e.clientY - tmp.top
    el.style.top = diffy < 0 ? 0 : diffy + 'px'
    el.style.left = diffx < 0 ? 0 : diffx + 'px'
    el.style.right = ''
  }

  /**
   * 按下鼠标
   * @param {MouseEvent} e 鼠标事件
   */
  const mousedownHandler = (e) => {
    e.preventDefault()
    isPress = true
    document.addEventListener('mouseup', mouseupHandler)
    document.addEventListener('mousemove', moveHandler)
  }

  /**
   * 松开鼠标
   * @param {MouseEvent} e 鼠标事件
   */
  const mouseupHandler = (e) => {
    isPress = false
    document.removeEventListener('mouseup', mouseupHandler)
    document.removeEventListener('mousemove', moveHandler)
  }

  ei.addEventListener('mousedown', mousedownHandler)
}

export default {
  inserted
}
